export default {
  logout: 'Выйти',
  signin: 'Войти',
  user: 'Логин',
  password: 'Пароль',
  validations: {
    inputUser: 'Введите имя пользователя',
    inputPassword: 'Введите пароль',
    required: 'Обязательно к заполнению'
  },
  errors: {
    isLocked: 'Пользователь заблокирован',
    wrongLogin: 'Неверный логин или пароль',
    unknownError: 'Неизвестная ошибка',
    serverError: '500 Внутренняя ошибка сервера',
    readBriefingsDenied: 'У пользователя отсутствует разрешение просмотра брифингов',
    'no-server-connection': 'Нет соединения с сервером'
  },
  success: {
    title: 'Успех',
    message: 'Обновления получены',
    copied: 'Скопировано'
  },
  info: {
    noUpdates: 'Обновлений нет',
    'latest-update': 'Последнее обновление: {time}'
  },
  navbar: {
    search: 'Поиск…',
    dateStart: 'С',
    dateEnd: 'По',
    profile: 'Профиль'
  },
  notification: {
    success: 'Успех',
    error: 'Ошибка',
    errors: 'Ошибки:',
    warning: 'Предупреждение',
    info: 'Информация'
  },
  'no-briefings': 'Нет брифингов за указанный период!',
  default: 'По умолчанию',
  download: 'Скачать',
  notes: 'Заметки',
  'add-note': 'Добавить заметку',
  'add-file': 'Добавить',
  delete: 'Удалить',
  cancel: 'Отмена',
  reload: 'Обновить',
  'confirm-deletion': 'Подтвердите удаление файла',
  apply: 'Применить',
  approve: 'Подтвердить',
  save: 'Сохранить',
  reset: 'Сбросить',
  yes: 'Да',
  confirmation: 'Подтверждение действия',
  'download-version': 'Скачать версию',
  'download-confirmed': 'Скачать подтвержденный',
  'download-draft': 'Скачать черновик',
  'download-signed': 'Скачать подписанный',
  'send-briefing': 'Отправить брифинг',
  'send-confirmed': 'Отправить подтвержденный',
  'send-draft': 'Отправить черновик',
  'num-of-emails-sent': 'Успешно отправлено:',
  settings: 'Настройки',
  'input-email': 'Ввод Email',
  'your-comment': 'Ваш комментарий',
  'add-comment': 'Добавьте комментарий…',
  'additional-info': 'Доп информация',
  'send-email': {
    'add-additional-recipients': 'Добавьте дополнительные адреса',
    'additional-recipients': 'Дополнительные адресаты',
    'invalid-address': 'Проверьте список получателей. Некорректные адреса:',
    sending: 'Отправка…'
  },
  file: {
    'download-upload-documents': 'Скачать/загрузить документы',
    upload: 'Загрузить',
    download: 'Скачать',
    'upload-to-server': 'Отправить',
    'open-pdf': 'Открыть PDF',
    auto: 'Авто',
    manual: 'Ручные',
    total: 'Итоговый',
    nofiles: 'Нет файлов',
    'generate-pdf': 'Сгенерировать pdf',
    'valid-until': 'Годен до: {date}',
    size: 'Размер',
    bytes: 'Б',
    kb: 'КБ',
    mb: 'МБ',
    invalidFileFormat: 'Недопустимый формат файла',
    acceptableFormats: 'Допустимые форматы'
  },
  'desks-filter': {
    desk: 'Группа',
    'check-all': 'Выбрать всё'
  },
  'fleet-filter': {
    'flight-code': 'Код авиакомпании',
    'vehicle-type': 'Вид ВС',
    helicopters: 'Вертолёты',
    planes: 'Самолёты'
  },
  'user-data': {
    title: 'Личные данные',
    name: 'Имя',
    phone: 'Телефон',
    email: 'Электронная почта'
  },
  pages: {
    error404: '404',
    profile: 'Профиль',
    briefings: 'Брифинги',
    login: 'Вход'
  },
  typeOfCrew: 'Тип экипажа',
  'select-locale': 'Выбрать язык',
  'build-info': 'Версия: { version } Дата сборки: { buildDate }',
  'table-headers': {
    version: 'Версия',
    status: 'Статус',
    flight: 'Рейс',
    briefing: 'Брифинг',
    pic: 'КВС',
    duty: 'Обяз.',
    number: '№'
  },
  'date-filter': {
    from: 'с',
    to: 'до',
    h: 'ч'
  },
  userSettings: {
    shiftTimeStart: 'Начало сдвига времени',
    shiftTimeEnd: 'Конец сдвига времени',
    settingsReset: 'Настройки сброшены',
    settingsSaved: 'Настройки сохранены',
    'undo-changes': 'Отменить изменения',
    compactTable: 'Компактный режим таблицы',
    viewsFiles: 'Просмотр файлов',
    displayedPortCode: 'Отображаемый код порта',
    showFormattedPhones: 'Показывать отформатированные телефонные номера',
    'enable-dark-theme': 'Использовать тёмную тему',
    'show-desk': 'Показывать группу рейса'
  },
  'email-not-listed': 'Почта не указана',
  'phone-not-listed': 'Телефон не указан',
  'aircraft-crew': 'Экипаж',
  history: 'История изменений',
  'update-time': 'Время обновления',
  updated: 'Обновлено',
  before: 'Было',
  after: 'Стало',
  'mark-as-read': 'Ознакомлен',
  restoreDefaultValues: 'Восстановить значения по умолчанию',
  enableCompactMode: 'Включить компактный режим',
  setNumOfCopies: 'Настроить количество копий',
  noFilesInSection: 'В секции отсутствуют файлы',
  'not-available': 'Н/Д',
  'download-date': 'Дата скачивания',
  'date-of-signing': 'Дата подписания',
  'rejection-date': 'Дата отклонения',
  'date-of-change': 'Дата изменения',
  'change-section': {
    'apply-changes': 'Принять изменения',
    'ignore-changes': 'Игнорировать изменения',
    updating: 'Обновление секции…'
  },
  common: {
    'compiled-version': 'Скомпилированная версия',
    'creation-date': 'Дата создания',
    'refresh-data': 'Обновить данные',
    commentary: 'Комментарий',
    copy: 'Копировать',
    date: 'Дата',
    downloading: 'Загрузка файла…',
    loading: 'Загрузка…',
    system: 'Система',
    all: '--все--'
  },
  filename: {
    'file-deleted': 'Файл удалён',
    'file-is-missing': 'Файл отсутствует'
  },
  cfp: {
    channel: {
      external: 'авто',
      fromArinc: 'из ARINC',
      fromPdf: 'из PDF',
      fromTxt: 'из TXT',
      manual: 'ручной'
    },
    'create-from-arinc': 'Создать из ARINC',
    'create-from-pdf': 'Создать из PDF',
    'create-from-txt': 'Создать из TXT',
    'file-will-be-replaced': 'Файл будет заменён',
    'files-can-be-replaced': 'Файлы могут быть заменены',
    'open-original': 'Открыть оригинал',
    'source-file-is-missing': 'Файл-исходник отсутствует',
    'upload-manually': 'Загрузить вручную',
    replace: 'Заменить'
  },
  'briefing-history': {
    title: 'История изменений брифинга',
    'current-version': 'Текущая версия',
    'only-approved': 'Только подтверждённые'
  },
  'cell-briefing': {
    'approve-briefing': 'Утверждение брифинга',
    'cancel-briefing': 'Отмена брифинга',
    'date-of-confirmation': 'Дата подтверждения',
    'download-archive': 'Скачать архив',
    'download-briefing': 'Скачать брифинг',
    'files-missing': 'В секциях отсутствуют файлы',
    'private-comment': 'Приватный комментарий',
    'send-email': 'Отправить по email',
    comment: 'Комментировать',
    dispatcher: 'Диспетчер'
  },
  'pic-actions': {
    acceptance: 'Подписание',
    action: 'Действие',
    correction: 'Корректировка',
    history: 'История действий',
    rejection: 'Отклонение',
    navlog: 'Заполнен Navlog',
    details: 'Детали',
    fuel: 'Топливо: ',
    comment: 'Комментарий: ',
    'not-processed': 'Не обработан',
    processed: 'Обработан',
    'processed-date': 'Дата обработки: ',
    'processing-attempt': 'Попытка: ',
    'processed-error': 'Ошибка при обработке: '
  }
}
